import Vue from 'vue';
import moment from 'moment';
/**
 * Transforme un date dans le format suivant : MMM YYYY. Exemple : Juil 2020.
 * @param value Date à transformer.
 * @returns La date au format MMM YYYY ou undefined.
 */
Vue.filter('Date', function(value, format) {
    if (value) {
        return moment(String(value)).format(format);
    }
});
